export default class GetPendingFollowRequests {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  /**
   * Récupérer les demandes d'abonnement en attente pour un utilisateur
   * @param {string} userId - ID de l'utilisateur
   * @returns {Promise<string[]>} - Liste des IDs des utilisateurs à qui l'utilisateur a envoyé une demande
   */
  async execute(userId) {
    try {
      console.log(`GetPendingFollowRequests UseCase - Récupération des demandes pour ${userId}`);
      
      if (!userId) {
        throw new Error('User ID is required');
      }
      
      return await this.userRepository.getPendingFollowRequests(userId);
    } catch (error) {
      console.error('Erreur dans GetPendingFollowRequests UseCase:', error);
      throw error;
    }
  }
} 